export default "__VITE_ASSET__DYuXnVdn__"